/**
 * Admin → Monitoring display rules (Kapil 11/1). Times read in Central, the
 * way RM reads them; the server's handoff text uses the same.
 */

const CT = 'America/Chicago'

export function ctTime(date, { withDay = true } = {}) {
  if (!date)
    return ''
  const opts = withDay
    ? { timeZone: CT, month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }
    : { timeZone: CT, hour: 'numeric', minute: '2-digit' }

  return new Intl.DateTimeFormat('en-US', opts).format(new Date(date))
}

export function duration(ms) {
  const totalMinutes = Math.max(0, Math.round(ms / 60000))
  if (totalMinutes < 60)
    return `${totalMinutes}m`
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours < 24)
    return minutes ? `${hours}h ${minutes}m` : `${hours}h`
  const days = Math.floor(hours / 24)
  const rem = hours % 24

  return rem ? `${days}d ${rem}h` : `${days}d`
}

function times(n) {
  return n === 1 ? 'once' : `${n} times`
}

/**
 * The one meta line under an issue's title.
 *   open:    "Since Nov 1, 11:21 AM · 23 times · last 7:24 PM"
 *   cleared: "Cleared Nov 1, 3:10 PM after 2h · 5 times"
 */
export function issueMeta(issue) {
  if (!issue)
    return ''
  if (issue.open) {
    const parts = [`Since ${ctTime(issue.firstFailedAt)}`, times(issue.failureCount || 0)]
    if (issue.failureCount > 1 && issue.lastFailedAt)
      parts.push(`last ${ctTime(issue.lastFailedAt, { withDay: false })}`)

    return parts.join(' · ')
  }
  const lasted = issue.recoveredAt && issue.firstFailedAt
    ? ` after ${duration(new Date(issue.recoveredAt) - new Date(issue.firstFailedAt))}`
    : ''

  return `Cleared ${ctTime(issue.recoveredAt)}${lasted} · ${times(issue.failureCount || 0)}`
}

/** "Muted until Nov 2, 7:00 PM" or '' when not muted. */
export function muteLabel(issue, now = new Date()) {
  if (!issue?.mutedUntil || new Date(issue.mutedUntil) <= now)
    return ''

  return `Muted until ${ctTime(issue.mutedUntil)}`
}

/** The menu badge text: '' for none, '9+' past nine. */
export function badgeText(count) {
  const n = Number(count) || 0
  if (n <= 0)
    return ''

  return n > 9 ? '9+' : String(n)
}
